module.exports = __webpack_public_path__ + "static/victoria-logo-colour-7a2942d9871e0b213e45475ce5831bd0.png";